import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarOff, Trash2, Plus } from "lucide-react";
import { adminApi, fmtDate } from "./adminApi";

export const ClosuresPanel = () => {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ date: "", note: "" });
  const load = () => adminApi.get("/admin/closures").then(({ data }) => setItems(Array.isArray(data) ? data : [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try { await adminApi.post("/admin/closures", form); setForm({ date: "", note: "" }); load(); toast.success("Giorno chiuso: non sarà prenotabile online"); }
    catch (err) { toast.error(err.response?.data?.detail || "Operazione non riuscita"); }
  };
  const remove = async (d) => {
    try { await adminApi.delete(`/admin/closures/${d}`); load(); toast.success("Giorno riaperto"); }
    catch (err) { toast.error(err.response?.data?.detail || "Operazione non riuscita"); }
  };

  return (
    <div className="mt-10 rounded-[1.5rem] bg-[#FCFBF7] border border-[#1B3B28]/10 p-6" data-testid="closures-panel">
      <p className="f-serif text-2xl text-[#1B3B28] flex items-center gap-2"><CalendarOff size={20} /> Giorni di chiusura</p>
      <p className="text-sm text-[#526356] mt-1">Ferie, festivi o assenze: nei giorni indicati i pazienti non possono scegliere orari online. Le visite si prenotano da martedì a venerdì, 9:00–18:00, ogni 45 minuti.</p>
      <form onSubmit={add} className="mt-5 flex flex-wrap gap-2">
        <input type="date" required value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} data-testid="closure-date-input"
          className="rounded-full border border-[#1B3B28]/15 bg-transparent px-4 py-2.5 text-sm text-[#1B3B28]" />
        <input value={form.note} maxLength={120} onChange={(e) => setForm({ ...form, note: e.target.value })} placeholder="Motivo (facoltativo)" data-testid="closure-note-input"
          className="flex-1 min-w-[180px] rounded-full border border-[#1B3B28]/15 bg-transparent px-4 py-2.5 text-sm text-[#1B3B28]" />
        <button type="submit" data-testid="closure-add-btn" className="inline-flex items-center gap-2 rounded-full bg-[#1B3B28] text-[#FCFBF7] px-5 py-2.5 text-sm hover:bg-[#3E6B48]"><Plus size={15} /> Chiudi giorno</button>
      </form>
      <div className="mt-4 flex flex-wrap gap-2">
        {items.map((c) => (
          <span key={c.date} className="inline-flex items-center gap-2 rounded-full bg-[#F3E6D8] text-[#5A3B1A] pl-4 pr-1.5 py-1.5 text-sm" data-testid={`closure-${c.date}`}>
            <span className="capitalize">{fmtDate(c.date, { weekday: "short", day: "numeric", month: "short" })}</span>{c.note && <span className="opacity-70">· {c.note}</span>}
            <button onClick={() => remove(c.date)} aria-label="Riapri giorno" data-testid={`closure-remove-${c.date}`} className="grid place-items-center w-7 h-7 rounded-full hover:bg-[#FCFBF7]/60"><Trash2 size={13} /></button>
          </span>
        ))}
        {!items.length && <span className="text-sm text-[#526356]">Nessuna chiusura programmata.</span>}
      </div>
    </div>
  );
};
